import axios from "axios";

// Environment variable for the API URL
// Use REACT_APP_API_URL environment variable if set.
// Fallback to the known public IP of this machine for development purposes.
const API_URL = process.env.REACT_APP_API_URL || "http://18.223.50.152:5000";

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  // withCredentials set to false to avoid CORS issues with default backend setup.
  // If authentication/cookies are needed, set this to true AND update backend CORS policy.
  withCredentials: false, 
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);
